import { curry, reduce, toPairs } from 'lodash/fp';
import { Suspense } from 'react';
import { Redirect } from 'react-router';
import GlobalInterceptorModal from '../react/components/Interceptor/GlobalInterceptorModal';
import LoadingIndicatorFull from '../react/components/LoadingIndicatorFull';
import NotificationsPage from '../react/components/Notifications/NotificationsPage';
import RichTextAreaTestPage from '../react/components/RichTextArea/TestPage/lazy';
import AdminBouncedEmails from '../react/features/Admin/BouncedEmails/lazy';
import CompanySettings from '../react/features/Admin/CompanySettings';
import AdminCompanySettingsPage from '../react/features/Admin/CompanySettings/lazy';
import AdminCustomWordingPage from '../react/features/Admin/CustomWordingPage/lazy';
import AdminDeleteCompanyPage from '../react/features/Admin/DeleteCompanyPage';
import EarlyAccessProgramPage from '../react/features/Admin/EarlyAccessProgram/lazy';
import AdminEmailReportsPage from '../react/features/Admin/EmailReports';
import AdminFeatureSelectionPage from '../react/features/Admin/FeatureSelection/lazy';
import AdminHelpfulResourcesPage from '../react/features/Admin/HelpfulResources/lazy';
import AdminMailLog from '../react/features/Admin/MailLog/lazy';
import AdminMergeUsersPage from '../react/features/Admin/MergeUsersPage/lazy';
import MessageStatisticsPage from '../react/features/Admin/MessageStatisticsPage/lazy';
import AdminObjectiveCategoriesPage from '../react/features/Admin/ObjectiveCategoriesPage/lazy';
import AdminObjectiveRatingsPage from '../react/features/Admin/ObjectiveRatingsPage/lazy';
import AdminOverviewPage from '../react/features/Admin/Overview';
import AdminSampleContentResetProgressPage from '../react/features/Admin/SampleContentPage/ProgressPage/lazy';
import AdminSampleContentPage from '../react/features/Admin/SampleContentPage/lazy';
import AdminDashboardPage from '../react/features/AdminDashboardPage/lazy';
import AiCopilot from '../react/features/AiCopilot/lazy';
import RequestFeedbackAdminPage from '../react/features/AnytimeFeedback/pages/AnytimeFeedbackAdminPage/lazy';
import AnytimeFeedbackProvidePage from '../react/features/AnytimeFeedback/pages/AnytimeFeedbackProvide';
import AnytimeFeedbackRequestCreate from '../react/features/AnytimeFeedback/pages/AnytimeFeedbackRequestCreate/lazy';
import AnytimeFeedbackRequestEdit from '../react/features/AnytimeFeedback/pages/AnytimeFeedbackRequestEdit/lazy';
import Automations from '../react/features/Automations/lazy';
import BillingAdminPage from '../react/features/Billing/pages/AdminPage/lazy';
import BillingCheckoutPage from '../react/features/Billing/pages/CheckoutPage/lazy';
import BillingObserverCompanyPage from '../react/features/Billing/pages/ObserverCompanyPage/lazy';
import CompanyAnalytics from '../react/features/CompanyAnalytics/lazy';
import AuditLogPage from '../react/features/CompanyObserver/pages/AuditLogPage/lazy';
import CompanyListPage from '../react/features/CompanyObserver/pages/CompanyListPage/lazy';
import CompanyObserverPage from '../react/features/CompanyObserver/pages/CompanyPage/lazy';
import MergeCompanyPage from '../react/features/CompanyObserver/pages/MergeCompanyPage/lazy';
import RolesPage from '../react/features/CompanyObserver/pages/Roles/lazy';
import SurveyObserverPage from '../react/features/CompanyObserver/pages/SurveyObserverPage/lazy';
import CompanyPage from '../react/features/CompanyPage';
import CustomerHealthCompany from '../react/features/CustomerHealth/pages/Company/lazy';
import CustomerHealthOverview from '../react/features/CustomerHealth/pages/OverviewPage/lazy';
import FeedbackPreviewPage from '../react/features/CycleFeedback/pages/FeedbackPreviewPage';
import FeedbackProvidePage from '../react/features/CycleFeedback/pages/FeedbackProvide';
import DirectoryAdminPage from '../react/features/DirectoryAdminPage/lazy';
import EmailManagePage from '../react/features/EmailTemplates/pages/EmailManagePage/lazy';
import ExperimentCreate from '../react/features/ExperimentObserver/ExperimentCreate/lazy';
import ExperimentDetails from '../react/features/ExperimentObserver/ExperimentDetails/lazy';
import ExperimentOverview from '../react/features/ExperimentObserver/ExperimentOverview/lazy';
import FeaturePage from '../react/features/FeaturesObserver/FeaturePage/lazy';
import FeaturesObserver from '../react/features/FeaturesObserver/lazy';
import FeedbackAdminPage from '../react/features/Feedback/pages/FeedbackAdminPage/lazy';
import FeedbackCycleCopyPage from '../react/features/FeedbackCycleCreate/pages/CopyPage';
import FeedbackCycleCreatePage from '../react/features/FeedbackCycleCreate/pages/CreatePage';
import FeedbackCycleEditPage from '../react/features/FeedbackCycleCreate/pages/EditPage';
import Home from '../react/features/Home/lazy';
import Inbox from '../react/features/Inbox/lazy';
import IntegrationsPage from '../react/features/Integrations';
import AdminBambooPage from '../react/features/Integrations/Bamboo/lazy';
import AdminCsvConfigPage from '../react/features/Integrations/CSV/lazy';
import AdminCalendarIntegration from '../react/features/Integrations/CalendarIntegration/lazy';
import AdminCustomCsvPage from '../react/features/Integrations/CustomCsv/lazy';
import AdminGoogleWorkspacePage from '../react/features/Integrations/GoogleWorkspace/lazy';
import AdminNamelyPage from '../react/features/Integrations/NamelyPage/lazy';
import AdminPersonioPage from '../react/features/Integrations/Personio/lazy';
import AdminSftpPage from '../react/features/Integrations/SFTP/lazy';
import AdminSaplingPage from '../react/features/Integrations/Sapling/lazy';
import AdminWorkablePage from '../react/features/Integrations/Workable';
import AdminWorkdayPage from '../react/features/Integrations/Workday/lazy';
import MeetingTemplatesCreate from '../react/features/MeetingTemplates/Create/lazy';
import MeetingTemplatesEdit from '../react/features/MeetingTemplates/Edit/lazy';
import MeetingDedicatedPage from '../react/features/Meetings/MeetingDedicatedPage/lazy';
import MeetingOverviewPageV2 from '../react/features/Meetings/MeetingOverviewPage/lazy';
import MeetingSpacePage from '../react/features/Meetings/MeetingSpacePage/lazy';
import MeetingsAdminPage from '../react/features/Meetings/pages/MeetingsAdminPage/lazy';
import MessageAdminEmailsPage from '../react/features/Messages/pages/MessageAdminPage/MessageAdminEmailsPage/lazy';
import AdminMessages from '../react/features/Messages/pages/MessageAdminPage/MessageSettingsPage/lazy';
import ObjectiveAdminCyclePage from '../react/features/Objectives/AdminCyclePage/lazy';
import ObjectiveClone from '../react/features/Objectives/Clone/lazy';
import ObjectiveCycleCopyPage from '../react/features/Objectives/CycleCreate/pages/CopyPage';
import ObjectiveCycleCreatePage from '../react/features/Objectives/CycleCreate/pages/CreatePage';
import ObjectiveCycleEditPage from '../react/features/Objectives/CycleCreate/pages/EditPage';
import ObjectiveSingleById from '../react/features/Objectives/pages/ObjectiveSingleById';
import ObjectiveAdminEmails from '../react/features/Objectives/pages/ObjectivesAdminPage/AdminEmails/lazy';
import YourObjectivesPage from '../react/features/Objectives/pages/YourObjectivesPage/lazy';
import OnboardingSurveyDemographicStep from '../react/features/OnboardingSurvey/OnboardingSurveyDemographicStep';
import OnboardingSurveyDone from '../react/features/OnboardingSurvey/OnboardingSurveyDone';
import OnboardingSurveyHris from '../react/features/OnboardingSurvey/OnboardingSurveyHris';
import OnboardingSurveyInterestStep from '../react/features/OnboardingSurvey/OnboardingSurveyInterestStep';
import OnboardingSurveyOrigin from '../react/features/OnboardingSurvey/OnboardingSurveyOrigin';
import PeoplePage from '../react/features/PeoplePage';
import PersonalAccessTokensPage from '../react/features/PersonalAccessTokens/lazy';
import PraiseAdminEmailsPage from '../react/features/Praise/pages/AdminPage/PraiseAdminEmailsPage/lazy';
import PraiseAdminPage from '../react/features/Praise/pages/AdminPage/lazy';
import PraiseSinglePage from '../react/features/Praise/pages/SinglePage/lazy';
import PraiseStreamPage from '../react/features/Praise/pages/StreamPage/lazy';
import Retention from '../react/features/Retention/lazy';
import ReviewCycleCopyPage from '../react/features/ReviewCycleCreate/pages/CopyPage';
import ReviewCycleCreatePage from '../react/features/ReviewCycleCreate/pages/CreatePage';
import ReviewCycleEditPage from '../react/features/ReviewCycleCreate/pages/EditPage';
import ReviewQuestionnaireAdminPage from '../react/features/ReviewQuestionnaireAdminPage/lazy';
import ReviewsEditPage from '../react/features/Reviews/pages/EditPage';
import ReviewsPreviewEditPage from '../react/features/Reviews/pages/PreviewEditPage';
import ReviewAdminPage from '../react/features/Reviews/pages/ReviewAdminPage/lazy';
import ReviewsViewPage from '../react/features/Reviews/pages/ViewPage/lazy';
import SharedMeetingDedicated from '../react/features/SharedMeetings/Dedicated/lazy';
import SharedMeetingsList from '../react/features/SharedMeetings/List/lazy';
import SurveyAdminPage from '../react/features/Surveys/pages/SurveyAdminPage/lazy';
import SurveyAnswerPage from '../react/features/Surveys/pages/SurveyAnswerPage/lazy';
import SurveyCreatePage from '../react/features/Surveys/pages/SurveyCreatePage/lazy';
import SurveyDashboardPage from '../react/features/Surveys/pages/SurveyDashboardPage/lazy';
import SurveyPrintPage from '../react/features/Surveys/pages/SurveyPrintPage/lazy';
import YourSurveysPage from '../react/features/Surveys/pages/YourSurveysPage/lazy';
import TeamPage from '../react/features/TeamPage';
import UsageSourceStatistics from '../react/features/UsageSourceStatistics/lazy';
import UserExportDataPage from '../react/features/User/pages/ExportDataPage/lazy';
import UserProfile from '../react/features/User/pages/UserProfile/lazy';
import UserSettingsPage from '../react/features/UserSettings/lazy';
import UserToEmailList from '../react/features/UserToEmailList/lazy';
import ViewFeedback from '../react/features/YourFeedback/View/lazy';
import YourFeedbackViewMultiple from '../react/features/YourFeedback/ViewFeedbackYouProvided/lazy';
import YourFeedback from '../react/features/YourFeedback/lazy';
import YourReviews from '../react/features/YourReviews/lazy';
import { useAppContext } from '../react/hooks/useAppContext';
import { isFeatureEnabled } from '../react/services/Features';
import redirects, { renderLastRedirects } from '../redirects';
import * as ROUTES from '../routes';
import { getAdminRouteForNavigation } from '../routes-pairs';
import { CONFIRMED_WICKET_ROUTES, REGULAR_WICKET_ROUTES } from '../routes-wicket';
import AngularRouteFetcher from './AngularRouteFetcher';
import ConfirmIdentityRoute from './DecoratedRoutes/ConfirmIdentityRoute';
import RestrictedRoute from './DecoratedRoutes/RestrictedRoute';
import ModalRoutes from './ModalRoutes';
import PageRoute from './PageRoute';
import RouteError from './RouteError';
import RoutesWrapper from './RoutesWrapper';
import ScrollToTop from './ScrollToTop';
import WicketRouteRenderer from './WicketRouteRenderer/lazy';
import angularRoutes, { childRoutes, restrictedRoutes } from './angularRoutes';

const getHref = (to, props) => {
    const path = typeof to === 'function' ? to(props) : to;
    return reduce((mem, [key, val]) => mem.replace(':' + key, val), path)(toPairs(props.match.params));
};

const redirectRender = curry((to, props) => <Redirect to={getHref(to, props)} />);

export default function AppRoutes() {
    const { user: currentUser } = useAppContext();

    return (
        <>
            <ScrollToTop />
            <Suspense fallback={<LoadingIndicatorFull />}>
                <RoutesWrapper
                    zenRoutes={[
                        [
                            ROUTES.COMPANY_ONBOARDING_DEMOGRAPHIC,
                            ({ location, prevPath }) => (
                                <OnboardingSurveyDemographicStep prevPath={prevPath} location={location} />
                            ),
                        ],
                        [
                            ROUTES.COMPANY_ONBOARDING_ORIGIN,
                            ({ location, prevPath }) => (
                                <OnboardingSurveyOrigin prevPath={prevPath} location={location} />
                            ),
                        ],
                        [
                            ROUTES.COMPANY_ONBOARDING_INTEREST,
                            ({ location, prevPath }) => (
                                <OnboardingSurveyInterestStep prevPath={prevPath} location={location} />
                            ),
                        ],
                        [
                            ROUTES.COMPANY_ONBOARDING_HRIS,
                            ({ location, prevPath }) => (
                                <OnboardingSurveyHris prevPath={prevPath} location={location} />
                            ),
                        ],
                        [
                            ROUTES.COMPANY_ONBOARDING_DONE,
                            ({ location, prevPath }) => (
                                <OnboardingSurveyDone prevPath={prevPath} location={location} />
                            ),
                        ],
                        [
                            ROUTES.REVIEW_EDIT,
                            ({ match, location, prevPath }) => (
                                <ReviewsEditPage
                                    reviewId={match.params.reviewId}
                                    prevPath={prevPath}
                                    location={location}
                                />
                            ),
                        ],
                        [
                            ROUTES.REVIEW_PREVIEW_QUESTIONNAIRE,
                            ({ match, location, prevPath }) => (
                                <ReviewsPreviewEditPage
                                    cycleId={match.params.cycleId}
                                    prevPath={prevPath}
                                    location={location}
                                />
                            ),
                        ],
                        [
                            ROUTES.ANYTIME_FEEDBACK_PROVIDE,
                            ({ match: { params }, prevPath }) => (
                                <AnytimeFeedbackProvidePage
                                    requestId={params.requestId}
                                    reviewerId={params.reviewerId || currentUser.id}
                                    prevPath={prevPath}
                                />
                            ),
                        ],
                        [
                            ROUTES.ADMIN_SAMPLE_CONTENT_PROGRESS,
                            ({ match, location }) => (
                                <AdminSampleContentResetProgressPage mode={match.params.mode} location={location} />
                            ),
                        ],
                        [
                            ROUTES.FEEDBACK_PROVIDE,
                            ({ match: { params }, prevPath }) => (
                                <FeedbackProvidePage responseId={params.id} prevPath={prevPath} />
                            ),
                        ],
                        [
                            ROUTES.FEEDBACK_PREVIEW_ZEN,
                            ({ match, prevPath }) => (
                                <FeedbackPreviewPage cycleId={match.params.cycleId} prevPath={prevPath} />
                            ),
                        ],
                        [ROUTES.USER_EXPORT_DATA, ({ match }) => <UserExportDataPage userId={match.params.id} />],
                    ].concat(
                        isFeatureEnabled('surveys')
                            ? [
                                  [
                                      ROUTES.YOUR_SURVEYS_ANSWER_SURVEY,
                                      ({ match, prevPath }) => (
                                          <SurveyAnswerPage
                                              surveyInstanceId={match.params.surveyInstanceId}
                                              prevPath={prevPath}
                                          />
                                      ),
                                  ],
                                  [
                                      getAdminRouteForNavigation(
                                          isFeatureEnabled('FEATURE_layoutRefresh')
                                              ? ROUTES.YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT
                                              : ROUTES.YOUR_COMPANY_SURVEYS_WITH_SURVEY_PRINT
                                      ),
                                      ({ match: { params }, prevPath }) => (
                                          <SurveyPrintPage surveyId={params.surveyId} prevPath={prevPath} />
                                      ),
                                  ],
                              ]
                            : []
                    )}
                >
                    {redirects.map(([from, to]) => (
                        <PageRoute exact path={from} key={from} render={redirectRender(to)} />
                    ))}
                    <RestrictedRoute
                        exact
                        requiredRole={['HR Admin']}
                        path={ROUTES.ADMIN_OBJECTIVES_EMAILS}
                        render={() => <ObjectiveAdminEmails />}
                    />
                    {toPairs(angularRoutes).map(([path, stateGetter]) => (
                        <PageRoute
                            exact
                            key={path}
                            path={path}
                            render={({ match }) => <AngularRouteFetcher match={match} stateGetter={stateGetter} />}
                        />
                    ))}
                    <PageRoute exact path={ROUTES.DASHBOARD} render={() => <Home />} />
                    <PageRoute exact path={ROUTES.INBOX} render={() => <Inbox />} />
                    <PageRoute
                        exact
                        path={ROUTES.DASHBOARD_ITEM}
                        render={({ match }) => <Home highlightTodoItemId={match.params.itemId} />}
                    />
                    <PageRoute exact path={ROUTES.YOUR_REVIEWS} render={() => <YourReviews />} />
                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <PageRoute path={ROUTES.REVIEWS_TEAM} render={() => <YourReviews />} />
                    )}
                    <RestrictedRoute
                        exact
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={getAdminRouteForNavigation(ROUTES.ADMIN_MESSAGES)}
                        render={() => <AdminMessages />}
                    />
                    <RestrictedRoute
                        exact
                        requiredRole={['HR Admin']}
                        path={getAdminRouteForNavigation(ROUTES.ADMIN_MESSAGES_EMAILS)}
                        render={() => <MessageAdminEmailsPage />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.FEEDBACK_USER_VIEW}
                        render={({ match }) => (
                            <ViewFeedback feedbackId={match.params.id} variant="page" showPrintButton={false} />
                        )}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.FEEDBACK_USER_VIEW_MULTIPLE}
                        render={({ match }) => <YourFeedbackViewMultiple feedbackId={match.params.id} />}
                    />
                    <PageRoute path={ROUTES.FEEDBACK_USER} render={() => <YourFeedback />} />
                    <PageRoute
                        exact
                        path={ROUTES.REVIEW_VIEW}
                        render={({ match, location }) => (
                            <ReviewsViewPage reviewId={match.params.reviewId} state={location.state} />
                        )}
                    />
                    <PageRoute path={ROUTES.USER_SETTINGS} render={() => <UserSettingsPage />} />
                    <PageRoute path={ROUTES.YOUR_TEAM} render={({ match }) => <TeamPage match={match} />} />
                    <PageRoute path={ROUTES.YOUR_COMPANY} render={() => <CompanyPage />} />
                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <PageRoute path={ROUTES.PEOPLE} render={() => <PeoplePage />} />
                    )}
                    <PageRoute
                        exact
                        path={ROUTES.ANYTIME_FEEDBACK_REQUEST_CREATE}
                        render={({ location }) => (
                            <AnytimeFeedbackRequestCreate location={location} anytimeFeedbackType="REQUEST" />
                        )}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ANYTIME_FEEDBACK_REQUEST_EDIT}
                        render={({ match }) => (
                            <AnytimeFeedbackRequestEdit requestId={match.params.id} anytimeFeedbackType="REQUEST" />
                        )}
                    />
                    <RestrictedRoute
                        requiredFeature="FEATURE_anytimeFeedbackGive"
                        exact
                        path={ROUTES.ANYTIME_FEEDBACK_GIVE_CREATE}
                        render={({ location }) => (
                            <AnytimeFeedbackRequestCreate location={location} anytimeFeedbackType="GIVE" />
                        )}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.ADMIN_MERGE_USERS}
                        render={({ match }) => <AdminMergeUsersPage sourceUserId={match.params.sourceUserId} />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_OBJECTIVE_CATEGORIES}
                        render={() => <AdminObjectiveCategoriesPage />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_OBJECTIVE_RATINGS}
                        render={() => <AdminObjectiveRatingsPage />}
                    />

                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_FEEDBACK_CYCLE_CREATE}
                        render={() => <FeedbackCycleCreatePage />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_FEEDBACK_CYCLE_COPY}
                        render={({ match }) => <FeedbackCycleCopyPage cycleId={match.params.cycleId} />}
                    />
                    <PageRoute
                        exact
                        path={getAdminRouteForNavigation(ROUTES.FEEDBACK_CYCLE_EDIT_NEW)}
                        render={({ match }) => <FeedbackCycleEditPage cycleId={match.params.cycleId} />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_OBJECTIVE_CYCLE_CREATE}
                        render={() => <ObjectiveCycleCreatePage />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_OBJECTIVE_CYCLE_COPY}
                        render={({ match }) => <ObjectiveCycleCopyPage cycleId={match.params.cycleId} />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_OBJECTIVE_CYCLE_EDIT}
                        render={({ match }) => <ObjectiveCycleEditPage cycleId={match.params.cycleId} />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_REVIEW_CYCLE_CREATE}
                        render={({ match }) => <ReviewCycleCreatePage cycleId={match.params.cycleId} />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_REVIEW_CYCLE_COPY}
                        render={({ match }) => <ReviewCycleCopyPage cycleId={match.params.cycleId} />}
                    />
                    <PageRoute
                        exact
                        path={getAdminRouteForNavigation(ROUTES.REVIEW_CYCLE_EDIT)}
                        render={({ match }) => <ReviewCycleEditPage cycleId={match.params.cycleId} />}
                    />
                    <RestrictedRoute
                        requiredFeature="FEATURE_reviewTemplates"
                        exact
                        path={ROUTES.REVIEW_QUESTIONNAIRE_ADMIN_PAGE}
                        render={() => <ReviewQuestionnaireAdminPage />}
                    />

                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_BILLING}
                        render={({ location }) => <BillingAdminPage location={location} />}
                    />
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_BILLING_CHECKOUT_STEP}
                        render={({ match }) => <BillingCheckoutPage defaultStep={match.params.defaultStep} />}
                    />
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_BILLING_CHECKOUT}
                        render={() => <BillingCheckoutPage />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.OBSERVER_BILLING_COMPANY}
                        render={({ match }) => <BillingObserverCompanyPage companyId={match.params.companyId} />}
                    />

                    <PageRoute exact path={ROUTES.OBSERVER_COMPANY} render={() => <CompanyListPage />} />

                    <PageRoute
                        path={ROUTES.OBSERVER_COMPANY_PAGE}
                        render={({ match }) => (
                            <CompanyObserverPage companyId={match.params.companyId} matchUrl={match.url} />
                        )}
                    />

                    <PageRoute exact path={ROUTES.OBSERVER_EXPERIMENT} render={() => <ExperimentOverview />} />
                    <PageRoute exact path={ROUTES.OBSERVER_USERS_TO_EMAILS} render={() => <UserToEmailList />} />
                    <PageRoute path={ROUTES.OBSERVER_EXPERIMENT_CREATE} render={() => <ExperimentCreate />} />
                    <PageRoute
                        path={ROUTES.OBSERVER_EXPERIMENT_VIEW}
                        render={({ match }) => <ExperimentDetails codeId={match.params.codeId} />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.OBSERVER_SURVEY}
                        render={({ match }) => <SurveyObserverPage id={match.params.surveyId} />}
                    />
                    <PageRoute exact path={ROUTES.OBSERVER_FEATURES} render={() => <FeaturesObserver />} />
                    <PageRoute
                        exact
                        path={ROUTES.OBSERVER_FEATURES_BULK_TOGGLE}
                        render={({ match }) => <FeaturePage featureId={match.params.featureId} />}
                    />
                    <PageRoute exact path={ROUTES.OBSERVER_CUSTOMER_HEALTH} render={() => <CustomerHealthOverview />} />
                    <PageRoute
                        exact
                        path={ROUTES.OBSERVER_CUSTOMER_HEALTH_COMPANY}
                        render={({ match }) => <CustomerHealthCompany companyId={match.params.companyId} />}
                    />

                    <PageRoute exact path={ROUTES.OBSERVER_SOURCE_STATS} render={() => <UsageSourceStatistics />} />

                    <ConfirmIdentityRoute exact path={ROUTES.ROLES} render={() => <RolesPage />} />
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.AUDIT_LOG}
                        render={({ location: { search } }) => <AuditLogPage search={search} />}
                    />
                    <ConfirmIdentityRoute exact path={ROUTES.MERGE_COMPANY} render={() => <MergeCompanyPage />} />

                    <PageRoute exact path={ROUTES.PRAISE_STREAM} render={() => <PraiseStreamPage />} />
                    <PageRoute
                        exact
                        path={ROUTES.PRAISE_SINGLE}
                        render={({ location, match }) => <PraiseSinglePage id={match.params.id} location={location} />}
                    />
                    <PageRoute exact path={ROUTES.ADMIN_DATETIME} render={() => <CompanySettings />} />
                    <PageRoute exact path={ROUTES.ADMIN_COMPANY_SETTINGS} render={() => <AdminCompanySettingsPage />} />
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_DELETE_COMPANY}
                        render={() => <AdminDeleteCompanyPage />}
                    />

                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <PageRoute exact path={ROUTES.OBJECTIVE_BROWSER} render={() => <YourObjectivesPage />} />
                    )}

                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <PageRoute path={ROUTES.OBJECTIVES_TEAM} render={() => <YourObjectivesPage />} />
                    )}

                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <PageRoute path={ROUTES.OBJECTIVES_COMPANY} render={() => <YourObjectivesPage />} />
                    )}

                    <PageRoute
                        exact
                        path={ROUTES.OBJECTIVE_SINGLE_BY_ID}
                        render={({ match }) => <ObjectiveSingleById objectiveId={match.params.id} />}
                    />

                    <PageRoute
                        exact
                        path={ROUTES.OBJECTIVE_SINGLE}
                        render={({ match }) => (
                            <AngularRouteFetcher match={match} stateGetter={childRoutes[ROUTES.OBJECTIVE_SINGLE]} />
                        )}
                    />

                    <PageRoute
                        exact
                        path={ROUTES.OBJECTIVE_CLONE}
                        render={({ match }) => <ObjectiveClone id={match.params.id} />}
                    />

                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_HIP_CHAT}
                        render={() => 'HipChat is no longer supported'}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.INTEGRATIONS_BAMBOO}
                        render={({ location, history }) => <AdminBambooPage location={location} history={history} />}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.INTEGRATIONS_GOOGLE_WORKSPACE}
                        render={({ location, history }) => (
                            <AdminGoogleWorkspacePage location={location} history={history} />
                        )}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.INTEGRATIONS_NAMELY}
                        render={({ location, history }) => <AdminNamelyPage location={location} history={history} />}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.INTEGRATIONS_PERSONIO}
                        render={({ location, history }) => <AdminPersonioPage location={location} history={history} />}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.INTEGRATIONS_KALLIDUS}
                        render={({ location, history }) => <AdminSaplingPage location={location} history={history} />}
                    />
                    <ConfirmIdentityRoute
                        path={ROUTES.INTEGRATIONS_WORKABLE}
                        render={({ location, history }) => <AdminWorkablePage location={location} history={history} />}
                    />
                    <ConfirmIdentityRoute path={ROUTES.INTEGRATIONS_WORKDAY} render={() => <AdminWorkdayPage />} />
                    {isFeatureEnabled('FEATURE_userImportSftp') && (
                        <ConfirmIdentityRoute path={ROUTES.INTEGRATIONS_SFTP} render={() => <AdminSftpPage />} />
                    )}
                    <ConfirmIdentityRoute path={ROUTES.ADMIN_CSV} render={() => <AdminCsvConfigPage />} />
                    {isFeatureEnabled('FEATURE_userImportCustomCsv') && (
                        <ConfirmIdentityRoute
                            path={ROUTES.INTEGRATIONS_CUSTOM_CSV}
                            render={() => <AdminCustomCsvPage />}
                        />
                    )}
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.PERSONAL_ACCESS_TOKENS}
                        render={() => <PersonalAccessTokensPage />}
                    />
                    <PageRoute
                        path={ROUTES.INTEGRATIONS_CALENDAR_INTEGRATION}
                        render={({ location }) => <AdminCalendarIntegration location={location} />}
                    />

                    <ConfirmIdentityRoute
                        path={ROUTES.ADMIN_SAMPLE_CONTENT}
                        render={() => <AdminSampleContentPage />}
                    />
                    <PageRoute exact path={ROUTES.MEETING_OVERVIEW_TEMPLATE} render={() => <MeetingOverviewPageV2 />} />

                    <PageRoute exact path={ROUTES.MEETING_OVERVIEW_SHARED} render={() => <MeetingOverviewPageV2 />} />

                    <PageRoute
                        exact
                        path={ROUTES.MEETING_OVERVIEW_TEAM_INSIGHTS}
                        render={() => <MeetingOverviewPageV2 />}
                    />

                    <PageRoute exact path={ROUTES.MEETING_OVERVIEW} render={() => <MeetingOverviewPageV2 />} />

                    <PageRoute
                        exact
                        path={ROUTES.MEETING_PAGE}
                        render={({ match }) => <MeetingSpacePage userIds={match.params.userIds} />}
                    />

                    <PageRoute
                        exact
                        path={ROUTES.MEETING_DEDICATED}
                        render={({ match }) => <MeetingDedicatedPage meetingId={match.params.meetingId} />}
                    />

                    <PageRoute
                        exact
                        path={ROUTES.MEETING_SHARED}
                        render={({ match }) => <SharedMeetingsList userIds={match.params.userIds} />}
                    />

                    <PageRoute
                        exact
                        path={ROUTES.MEETING_SHARED_DEDICATED}
                        render={({ match }) => <SharedMeetingDedicated meetingId={match.params.meetingId} />}
                    />

                    {isFeatureEnabled('FEATURE_meetingUserTemplates') && (
                        <PageRoute
                            exact
                            path={ROUTES.MEETING_TEMPLATES_CREATE}
                            render={() => <MeetingTemplatesCreate type="USER" />}
                        />
                    )}

                    {isFeatureEnabled('FEATURE_meetingUserTemplates') && (
                        <PageRoute
                            exact
                            path={ROUTES.MEETING_TEMPLATES_EDIT}
                            render={props => <MeetingTemplatesEdit {...props} type="USER" />}
                        />
                    )}

                    <PageRoute exact path={ROUTES.NOTIFICATIONS_PAGE} render={() => <NotificationsPage />} />
                    <RestrictedRoute
                        requiredFeature="surveys"
                        exact
                        path={ROUTES.YOUR_SURVEYS}
                        render={() => <YourSurveysPage />}
                    />
                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <RestrictedRoute
                            requiredFeature="surveys"
                            exact
                            path={ROUTES.YOUR_SURVEYS_SHARED}
                            render={() => <YourSurveysPage />}
                        />
                    )}
                    {isFeatureEnabled('FEATURE_layoutRefresh') && (
                        <RestrictedRoute
                            requiredFeature="surveys"
                            exact
                            path={ROUTES.YOUR_SURVEYS_SHARED_WITH_SURVEY}
                            render={() => <YourSurveysPage />}
                        />
                    )}
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        requiredFeature="surveys"
                        exact
                        path={ROUTES.ADMIN_SURVEYS_EDIT}
                        render={({ match }) => <SurveyCreatePage surveyId={match.params.surveyId} mode="EDIT" />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        requiredFeature="surveys"
                        exact
                        path={ROUTES.ADMIN_SURVEYS_COPY}
                        render={({ match }) => <SurveyCreatePage surveyId={match.params.surveyId} mode="COPY" />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        requiredFeature="surveys"
                        exact
                        path={ROUTES.ADMIN_SURVEYS_CREATE}
                        render={() => <SurveyCreatePage mode="CREATE" />}
                    />
                    <RestrictedRoute
                        exact
                        requiredRole={['HR Admin', 'HR Assistant']}
                        allowCycleAdminsFor="OBJECTIVES"
                        path={ROUTES.ADMIN_OBJECTIVES_SELECT_CYCLE}
                        render={({ match }) => (
                            <AngularRouteFetcher
                                match={match}
                                stateGetter={restrictedRoutes[ROUTES.ADMIN_OBJECTIVES_SELECT_CYCLE]}
                            />
                        )}
                    />
                    <RestrictedRoute
                        exact
                        requiredRole={['HR Admin', 'HR Assistant']}
                        allowCycleAdminsFor="REVIEWS"
                        path={ROUTES.ADMIN_REVIEW_GRAPH_WITH_CYCLE}
                        render={({ match }) => (
                            <AngularRouteFetcher
                                match={match}
                                stateGetter={restrictedRoutes[ROUTES.ADMIN_REVIEW_GRAPH_WITH_CYCLE]}
                            />
                        )}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={ROUTES.ADMIN_DASHBOARD}
                        render={() => <AdminDashboardPage />}
                    />
                    {isFeatureEnabled('FEATURE_earlyAccessProgram') && (
                        <RestrictedRoute
                            requiredRole={['HR Admin', 'HR Assistant']}
                            path={ROUTES.ADMIN_EARLY_ACCESS_FEATURE}
                            render={({ match }) => <EarlyAccessProgramPage featureId={match.params.featureId} />}
                        />
                    )}
                    {isFeatureEnabled('FEATURE_earlyAccessProgram') && (
                        <RestrictedRoute
                            requiredRole={['HR Admin', 'HR Assistant', 'Tech Admin']}
                            path={ROUTES.ADMIN_EARLY_ACCESS}
                            render={() => <EarlyAccessProgramPage />}
                        />
                    )}
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={ROUTES.ADMIN_MEETINGS}
                        render={() => <MeetingsAdminPage />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin']}
                        path={ROUTES.ADMIN_PRAISE_EMAILS}
                        render={() => <PraiseAdminEmailsPage />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant', 'Tech Admin']}
                        path={ROUTES.ADMIN_PRAISE}
                        render={() => <PraiseAdminPage />}
                    />
                    {isFeatureEnabled('surveys') && (
                        <RestrictedRoute
                            exact
                            requiredRole={['HR Admin', 'HR Assistant']}
                            path={ROUTES.ADMIN_SURVEYS}
                            render={() => <SurveyAdminPage />}
                        />
                    )}
                    {isFeatureEnabled('surveys') && (
                        <RestrictedRoute
                            exact
                            requiredRole={['HR Admin', 'HR Assistant']}
                            path={ROUTES.ADMIN_SURVEYS_WITH_SURVEY}
                            render={({ match }) => <SurveyDashboardPage surveyId={match.params.surveyId} />}
                        />
                    )}
                    <RestrictedRoute
                        exact
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={ROUTES.ADMIN_OBJECTIVES_CYCLE_OVERVIEW}
                        allowCycleAdminsFor="OBJECTIVES"
                        render={() => <ObjectiveAdminCyclePage />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={ROUTES.ADMIN_FEEDBACK_SELECT_CYCLE}
                        allowCycleAdminsFor="360_FEEDBACK"
                        render={() => <FeedbackAdminPage />}
                    />

                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={ROUTES.ADMIN_FEEDBACK_REQUESTED}
                        render={() => <RequestFeedbackAdminPage />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant']}
                        path={ROUTES.ADMIN_REVIEWS_SELECT_CYCLE}
                        allowCycleAdminsFor="REVIEWS"
                        render={() => <ReviewAdminPage />}
                    />
                    <RestrictedRoute
                        requiredRole={['HR Admin', 'HR Assistant', 'Tech Admin']}
                        path={ROUTES.ADMIN_USERS_DIRECTORY}
                        render={() => <DirectoryAdminPage />}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_MAIL_LOG}
                        render={({ match, history, location }) => (
                            <AdminMailLog
                                companyId={match.params.companyId}
                                query={location.search}
                                updateQuery={query => history.push({ search: query })}
                            />
                        )}
                    />
                    <PageRoute
                        exact
                        path={ROUTES.ADMIN_MESSAGE_STATISTICS}
                        render={({ match, location }) => (
                            <MessageStatisticsPage
                                companyId={match.params.companyId ?? currentUser.company.id}
                                query={location.search}
                            />
                        )}
                    />
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_FEATURE_SELECTION}
                        render={() => <AdminFeatureSelectionPage />}
                    />
                    {isFeatureEnabled('FEATURE_clippyAttachments') && (
                        <PageRoute
                            exact
                            path={ROUTES.ADMIN_HELPFUL_RESOURCES}
                            render={() => <AdminHelpfulResourcesPage />}
                        />
                    )}
                    <ConfirmIdentityRoute
                        exact
                        path={ROUTES.ADMIN_CUSTOM_WORDING}
                        render={() => <AdminCustomWordingPage />}
                    />
                    <PageRoute exact path={ROUTES.ADMIN_REPORT_EMAILS} render={() => <AdminEmailReportsPage />} />
                    <PageRoute exact path={ROUTES.ADMIN_BOUNCED_EMAILS} render={() => <AdminBouncedEmails />} />
                    <PageRoute exact path={ROUTES.ADMIN_EMAIL_MANAGE} render={() => <EmailManagePage />} />
                    <PageRoute exact path={ROUTES.ADMIN_OVERVIEW} render={() => <AdminOverviewPage />} />
                    <PageRoute exact path={ROUTES.INTEGRATIONS} render={() => <IntegrationsPage />} />
                    <PageRoute
                        exact
                        path={ROUTES.USER_PROFILE}
                        render={({ match, location }) => <UserProfile userId={match.params.id} location={location} />}
                    />
                    {isFeatureEnabled('retention') && (
                        <ConfirmIdentityRoute
                            path={ROUTES.COMPANY_ANALYTICS}
                            render={({ match }) => <CompanyAnalytics companyId={match.params.companyId} />}
                        />
                    )}
                    {isFeatureEnabled('retention') && (
                        <ConfirmIdentityRoute
                            path={ROUTES.RETENTION}
                            render={({ match }) => <Retention match={match} />}
                        />
                    )}
                    {isFeatureEnabled('retention') && (
                        <ConfirmIdentityRoute
                            path={ROUTES.INSIGHTS}
                            render={({ match }) => <Retention match={match} />}
                        />
                    )}
                    {isFeatureEnabled('FEATURE_automationsEmployee') && (
                        <PageRoute
                            path={ROUTES.EMPLOYEE_AUTOMATIONS}
                            render={({ match }) => <Automations match={match} employeeView={true} />}
                        />
                    )}
                    {isFeatureEnabled('automations') && (
                        <RestrictedRoute
                            requiredRole={['HR Admin', 'HR Assistant']}
                            path={ROUTES.HR_AUTOMATIONS}
                            render={({ match }) => <Automations match={match} employeeView={false} />}
                        />
                    )}
                    {isFeatureEnabled('FEATURE_aiCopilot') && (
                        <PageRoute path={ROUTES.AI_COPILOT} render={({ match }) => <AiCopilot match={match} />} />
                    )}
                    <PageRoute exact path="/_rich-text-area-test-page" render={() => <RichTextAreaTestPage />} />
                    {CONFIRMED_WICKET_ROUTES.map(route => (
                        <ConfirmIdentityRoute
                            key={route}
                            path={route}
                            render={({ location }) => <WicketRouteRenderer url={location.pathname + location.search} />}
                        />
                    ))}
                    {REGULAR_WICKET_ROUTES.map(route => (
                        <PageRoute
                            key={route}
                            path={route}
                            render={({ location }) => <WicketRouteRenderer url={location.pathname + location.search} />}
                        />
                    ))}
                    {renderLastRedirects.map(([from, to]) => (
                        <PageRoute exact path={from} key={from} render={redirectRender(to)} />
                    ))}
                    <PageRoute render={() => <RouteError errorCode={404} />} />
                </RoutesWrapper>
                <ModalRoutes />
            </Suspense>
            <GlobalInterceptorModal />
        </>
    );
}
